import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Center, Flex, Text } from "@chakra-ui/react";
import { RoomPhotos } from "./components";

export const RoomFeed = ({ imgList }: { imgList: { img_URL: string }[] }) => {
    // const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });
    const { isMobile } = useDesignMaxTheme().MEDIAS();

    return (
        <Center position="relative" w="100%">
            <Center as="section" p={isMobile ? "40px 0 " : "0 160px 120px 160px"}>
                <Flex flexDir="column" p={isMobile ? "0 16px" : "0 48px"}>
                    <Text textAlign="right" color="#f5f3ef" {...FONT("cormorant", isMobile ? 40 : 104, 700, 1.2)}>
                        DETAIL
                    </Text>
                    <RoomPhotos imgList={imgList} />
                </Flex>
            </Center>
        </Center>
    );
};
